export default "__VITE_ASSET__DfvRH8sW__"